import { render } from "./Loader.vue?vue&type=template&id=e2e08c7a&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=e2e08c7a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e08c7a"]])

export default __exports__